import { useRef, useEffect } from 'react'
// Hook equivalent to useEffect, but skips callback on first render
export function useEffectUpdateOnly(fn: () => void, deps: any[]) {
  const didMountRef = useRef(false)

  useEffect(() => {
    if (didMountRef.current) {
      fn()
    } else {
      didMountRef.current = true
    }
    // Generic wrapper: `deps` is passed through from the caller and `fn` is intentionally
    // not a trigger, so exhaustive-deps cannot (and should not) verify this list.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
}
